import { render } from "./UnitEvaluationForm.vue?vue&type=template&id=4a8721b2&scoped=true"
import script from "./UnitEvaluationForm.vue?vue&type=script&lang=js"
export * from "./UnitEvaluationForm.vue?vue&type=script&lang=js"

import "./UnitEvaluationForm.vue?vue&type=style&index=0&id=4a8721b2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a8721b2"]])

export default __exports__